import { render, staticRenderFns } from "./CBProposalSafes.vue?vue&type=template&id=4f51e9e4"
import script from "./CBProposalSafes.vue?vue&type=script&lang=js"
export * from "./CBProposalSafes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports